import React, { FC } from 'react'
import styled from 'styled-components'

export const TrainingDataDescription: FC = () => {
  return (
    <div css="margin-bottom: 8px;">
      Please paste list of test cases separated by new lines you want to test against current step
      examples. Every test case is a pair of utterance and expected answer, separated by tab
      character. For example you can copy this format from any spreadsheet editor, such as:
      <br />
      <br />
      <pre>
        <table className="custom-modal-table-padding">
          <tr>
            <td>
              <strong>utterance</strong>
            </td>
            <td>
              <strong>answer</strong>
            </td>
          </tr>
          <tr>
            <td>how are you?</td>
            <td>how-are-you</td>
          </tr>
          <tr>
            <td>your name?</td>
            <td>user-name</td>
          </tr>
        </table>
      </pre>
      You can also still use the old formats of{' '}
      <InlineExample>utterance default---answer</InlineExample> and{' '}
      <InlineExample>utterance default answer</InlineExample>.
    </div>
  )
}

const InlineExample = styled.pre`
  display: inline;
  padding: 1px 4px;
`
